import React from 'react'
import { Grid } from 'react-styled-flexboxgrid'
import { ThemeProvider } from 'styled-components'
// import Styled from 'styled-components'
// import STYLE_CONSTANTS from '~/style/constants'

const FlexBoxGridTheme = {
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: '1',
    outerMargin: '0',
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 61,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 75
    }
  }
}

const Container = ({ children }) => {
  return (
    <ThemeProvider theme={FlexBoxGridTheme}>
      <Grid fluid>
        {children}
      </Grid>
    </ThemeProvider>
  )
}

export default Container
